import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { BuildingOffice2Icon, ArrowUturnLeftIcon } from '@heroicons/react/24/outline';
import { useMyOrganizations } from '@/hooks/useApi';
import { useAuthStore } from '@/stores/authStore';

export default function GuestOrgBanner() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const currentOrgId = useAuthStore((s) => s.organizationId);
  const setOrganizationId = useAuthStore((s) => s.setOrganizationId);
  const { data: memberships } = useMyOrganizations();

  if (!memberships || memberships.length === 0 || !currentOrgId) return null;

  const current = memberships.find((m) => m.organization.id === currentOrgId);
  // "own" org = the one where the user is super_admin (their personal org)
  const own = memberships.find((m) => m.role === 'super_admin');

  // Only show banner if user is currently NOT in their own org
  if (!own || !current || current.organization.id === own.organization.id) return null;

  const handleSwitchBack = async () => {
    setOrganizationId(own.organization.id);
    await qc.invalidateQueries();
  };

  return (
    <div className="sticky top-0 z-40 bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2.5 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <BuildingOffice2Icon className="h-5 w-5 shrink-0" />
          <span className="truncate">
            {t('team.guestBanner', {
              org: current.organization.name,
              role: t(`settings.roles.${current.role}`),
            })}
          </span>
        </div>
        <button
          onClick={handleSwitchBack}
          className="flex shrink-0 items-center gap-1.5 rounded-md bg-white/20 px-3 py-1 text-xs font-medium hover:bg-white/30 transition-colors"
        >
          <ArrowUturnLeftIcon className="h-4 w-4" />
          {t('team.backToOwn', { org: own.organization.name })}
        </button>
      </div>
    </div>
  );
}
